// =====================================================================
// Qué falta para poder recibir · Fase 4 de DIRECTRIZ-VENTAJA
// =====================================================================
// POR QUE EXISTE, CON EL CASO. La pantalla de recibir comprobaba sus
// cinco reglas **al pulsar «Recibir»**, y ni una antes. Quien llegaba
// con cuarenta referencias contadas se enteraba de que faltaba el lote
// del proveedor del renglón catorce cuando ya había terminado — y las
// reglas eran correctas, y los mensajes decían qué hacer. El defecto no
// es lo que dicen: es CUANDO lo dicen.
//
// La Doctrina 2 lo pide en dos puntos y esto es el mismo: «validación en
// vivo mientras se escribe, no al guardar» y «botones deshabilitados con
// la explicación visible de por qué». Prevenir mejor que regañar.
//
// =====================================================================
// LAS COMPROBACIONES DE «CONFIRMAR» NO SE QUITAN, Y NO ES DUPLICAR
// =====================================================================
// Esto no sustituye a nada: adelanta. Las de `onConfirmar` siguen ahí
// porque la cola sin señal encola sin pasar por esta pantalla, y las del
// servidor siguen ahí porque una regla que solo vive en el cliente se la
// salta cualquiera. Son tres capas del mismo muro y cada una protege de
// algo distinto.
//
// LO QUE SI EXIGE ES QUE DIGAN LO MISMO. Si esta lista y `onConfirmar`
// discreparan, habría un botón que parece listo y un error al pulsarlo,
// que es peor que no tener la lista. Por eso las reglas viven aquí, en
// una función sin React que se puede probar sola.
//
// =====================================================================
// CONTAR A CIEGAS MANDA SOBRE ESTO
// =====================================================================
// Contar a ciegas oculta lo que DEBERIA llegar; ése es el mecanismo
// entero, no un detalle de presentación. Así que la exigencia de foto
// —que solo se sabe comparando con lo pedido— se calla mientras se
// cuenta a ciegas, exactamente igual que se calla el aviso de la foto.
// Quien decide eso es `avisarDeLaFoto`, y aquí se recibe ya decidido:
// dos sitios calculándolo por su cuenta acabarían discrepando.

/** Lo que impide recibir ahora mismo. Lista vacía = se puede recibir.
 *
 * Cada estorbo trae `clave` (para la lista de React y para las pruebas)
 * y `texto`, que dice qué pasa y qué hacer, en ese orden.
 */
export function loQueFaltaParaRecibir({
  pendientes = [],
  cantidades = {},
  calidad = {},
  ubicacion = '',
  exigeLote = false,
  necesitaFoto = false,
  puedeDecirLoDeLaFoto = true,
  fotos = [],
} = {}) {
  const estorbos = [];

  const conCantidad = pendientes.filter(
    (r) => Number(cantidades[r.sku] || 0) > 0);

  if (!conCantidad.length) {
    estorbos.push({
      clave: 'cantidades',
      texto: 'No has indicado ninguna cantidad. Escanea las piezas o '
             + 'escribe cuánto llegó de al menos un producto.',
    });
  }

  if (!ubicacion) {
    estorbos.push({
      clave: 'ubicacion',
      texto: 'Falta elegir dónde entra la mercancía, arriba.',
    });
  }

  // EL LOTE INTERNO, solo donde el producto se maneja por lote. Mismo
  // criterio que el servidor: si las dos comprobaciones no dijeran lo
  // mismo, una de las dos estaría de más y la otra sería la que manda
  // sin que se note.
  const sinLoteInterno = conCantidad
    .filter((r) => r.controla_lote && !(calidad[r.sku]?.codigo_lote || '').trim())
    .map((r) => r.sku);
  if (sinLoteInterno.length) {
    estorbos.push({
      clave: 'lote-interno',
      texto: `Falta el número de lote en ${sinLoteInterno.join(', ')}. `
             + 'Esos productos se manejan por lote, así que sin él no se '
             + 'sabe qué tanda entró. Escríbelo como venga en la caja.',
    });
  }

  const sinLoteProveedor = exigeLote
    ? conCantidad
      .filter((r) => r.controla_lote
                     && !(calidad[r.sku]?.lote_proveedor || '').trim())
      .map((r) => r.sku)
    : [];
  if (sinLoteProveedor.length) {
    estorbos.push({
      clave: 'lote-proveedor',
      texto: 'Tu empresa exige registrar de qué lote del proveedor viene '
             + `el material, y falta en ${sinLoteProveedor.join(', ')}. `
             + 'Escribe el número que trae el certificado del proveedor.',
    });
  }

  if (necesitaFoto && puedeDecirLoDeLaFoto && !fotos.length) {
    estorbos.push({
      clave: 'foto',
      texto: 'Esta recepción tiene faltante, daño o rechazo y no lleva '
             + 'ninguna foto. Con foto y con la hora del servidor, lo que '
             + 'llegó mal es un documento. Toma al menos una.',
    });
  }

  return estorbos;
}
